import styled from "styled-components";
import backImage from "../../assets/images/backgroundInsights.png";
import { motion } from "framer-motion";

export const PageWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(${backImage});
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  padding: ${(props) =>
    props.isMobile ? "0 25px 48px 25px" : "0 98px 48px 98px"};
`;

export const CarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 40px 0;
  margin-bottom: 10px;
  will-change: transform;
`;

export const GradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 20;
  pointer-events: none;
  will-change: opacity; 

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: ${({ isMobile }) => (isMobile ? '20px' : '150px')};
    height: 100%;
    background: linear-gradient(
      to right,
      ${({ isMobile }) => (isMobile ? '#413F5F 0%' : '#413F5F 0%')},
      ${({ isMobile }) => (isMobile ? 'rgba(65, 63, 95, 0) 100%' : 'rgba(65, 63, 95, 0) 100%')}
    );
    transition: all 0.3s ease;
    will-change: transform, opacity;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
    background: linear-gradient(
      to left,
      #413F5F 0%,
      rgba(65, 63, 95, 0) 100%
    );
  }
`;

export const CarouselTrack = styled(motion.div)`
  display: flex;
  position: relative;
  will-change: transform; 
  backface-visibility: hidden;
  transform-style: preserve-3d; 
`;

export const CarouselItem = styled.div`
  flex: 0 0 auto;
  width: 150px;
  height: 200px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: rgba(255, 255, 255, 0.32); */
  border-radius: 10px;
  transition: transform 0.3s ease-out; 
  /* padding: 5px; */
  will-change: transform; 
  backface-visibility: hidden;
  
  &:hover {
    transform: scale(1.05) translateZ(0); 
    box-shadow: 0 5px 15px rgba(0,0,0,0.1); 
  }
`;

export const PersonImage = styled.img`
  width: 200px !important;
  height: 200px !important;
  object-fit: cover;
  border-radius: 15px;
`;

export const DualRowCarouselTrack = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px; 
`;